import { useMemo } from "react";

import type { ActivationAlertsContractSocialMediaChannel } from "@similarweb/pro-api-client";

import { useApiQuery } from "app/modules/api-client";

import { useActivationSet } from "../../../hooks/useActivationSet";
import { useActivationSetFavicons } from "../../../hooks/useActivationSetFavicons";
import { useCommonAlertsQueryParams } from "../../useCommonAlertsQueryParams";
import { useSocialAlertsFilterStore } from "../filters/useSocialAlertsFilterStore";
import { transformActivityAndAudienceData } from "../utils/transformActivityAndAudienceData";

export const useActivityAndAudienceData = () => {
    const params = useCommonAlertsQueryParams();
    const { activationSet, isLoading: isActivationSetLoading } = useActivationSet();
    const { favicons, isLoading: isFaviconsLoading } = useActivationSetFavicons();

    const selectedChannels = useSocialAlertsFilterStore((state) => state.selectedChannels);
    const isDefaultChannelsSelected = useSocialAlertsFilterStore((state) => state.isDefaultChannelsSelected);
    const socialNetworks = isDefaultChannelsSelected
        ? undefined
        : ([...selectedChannels.keys()] as ActivationAlertsContractSocialMediaChannel[]);

    const { data, isLoading: isDataLoading } = useApiQuery(
        {
            tag: "Alerts",
            methodName: "activationAlertsMetricsSocialMediaActivityAndAudienceDetail",
            options: {
                refetchOnMount: true,
            },
        },
        {
            ...params,
            socialNetworks,
        },
    );

    const transformedData = useMemo(() => {
        if (!data) {
            return [];
        }

        return transformActivityAndAudienceData({
            data,
            icons: favicons,
            primaryDomain: activationSet?.primaryDomain,
        });
    }, [activationSet?.primaryDomain, favicons, data]);

    return {
        data: transformedData,
        isLoading: isActivationSetLoading || isDataLoading || isFaviconsLoading,
    };
};
